if ($('.services-block').length) {

	$(".services-block .nav-item").on('click', function() {

		if ($(this).hasClass('.open')) {

		} else {
			$(".services-block .nav-item.open").removeClass('open');
			$(this).addClass('open');
			$('.nav-target.open').removeClass('open');
			$(".nav-target[data-target-id='"+$(this).data('id')+"']").addClass('open');
		}
		
	});

	let doHeight = function() {
		let maxHeight = 0;
		if (window.innerWidth >= 769) {
			$('.nav-target').each(function() {
				if ($(this).outerHeight() > maxHeight) {
					maxHeight = $(this).outerHeight();
				}
			});

			$('.services-target-container').height(maxHeight);
		} else {
			$('.services-target-container').removeAttr('style');
		}
	};

	doHeight();

	$(window).on('resize', doHeight);


	// Mobile
	$(function(){
		var init = false;
		function servicesSlick() {
		  if (window.innerWidth <= 768) {
		    if (!init) {
		      init = true;
		      $('.services-target-container').slick(
		      	{
		      		slidesToShow: 1,
  	            	slidesToScroll: 1,
  	            	prevArrow: $('.arrow-left'),
  	            	nextArrow: $('.arrow-right'),
  	            });
		    }
		  } else if (init) {
		    $('.services-target-container').slick('destroy');
		    init = false;
		  }
		}
		servicesSlick();
		window.addEventListener("resize", servicesSlick);
	});
};